import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const SETTINGS_API_PATH = '/api/settings';

const getSettings = async () => {
  const response = await axios.get(`${API_BASE_URL}${SETTINGS_API_PATH}`);
  return response.data.data;
};

const updateSettings = async (settingsData) => {
  const response = await axios.put(`${API_BASE_URL}${SETTINGS_API_PATH}`, settingsData);
  return response.data.data;
};

const getDiscountReasons = async () => {
  const response = await axios.get(`${API_BASE_URL}${SETTINGS_API_PATH}/discount-reasons`);
  return response.data.data;
};

const settingsService = { getSettings, updateSettings, getDiscountReasons };
export default settingsService;
